import React, { createContext, useContext, useReducer, ReactNode } from "react";
import { CredibilityIndexAction } from "./CredibilityIndex.action";
import { PageViewType } from "./CredibilityIndex.constants";

interface CIContextType {
  state: any;
  dispatch: React.Dispatch<any>;
}

export interface EditCredibilityBand {
    displayName: string;
    responseKey: string;
    flag: boolean | null;
    weightage: number | string;
}

interface StateType {
  isLoading: boolean;
  clientId: number | null;
  activePage: string;
  pageView: JSX.Element;
  getCiConfigResponse: any;
  isEditingWeightage: boolean;
  editWeightageValues: Record<string, any>;
  editCredibilityBand: EditCredibilityBand;
  isOverallBandEdited: boolean;
}

export const DataContext = createContext<CIContextType | null>(null);
export const useDataContext = () => useContext(DataContext);

const initialState: StateType = {
    isLoading: false,
    clientId: null,
    activePage: PageViewType.HOME_PAGE,
    pageView: <></>,
    getCiConfigResponse: null, 
    isEditingWeightage: false, 
    editWeightageValues: {},
    editCredibilityBand: {
        displayName: "",
        responseKey: "",
        flag: null,
        weightage: 0 
    },
    isOverallBandEdited: false
};

function dataReducer(state: any, action: any) {
  switch (action.type) {
    case CredibilityIndexAction.UPDATE_CLIENT_ID:
      return {
        ...state,
        clientId: action.payload.clientId
      };
    case CredibilityIndexAction.SET_CI_CONFIG_RESPONSE:
      return {
        ...state,
        getCiConfigResponse: action.payload.response,
        activePage: action.payload.activePage
      };
    case CredibilityIndexAction.UPDATE_PAGE_VIEW:
        return {
            ...state,
            pageView: action.payload.pageView
        };
    case CredibilityIndexAction.UPDATE_WEIGHTAGE_EDITING:
        return {
            ...state,
            editWeightageValues: action.payload.editWeightageValues
        };
    case CredibilityIndexAction.TOGGLE_EDIT_WEIGHTAGE:
        return {
            ...state,
            isEditingWeightage: !state.isEditingWeightage
        };
    case CredibilityIndexAction.UPDATE_ACTIVE_PAGE:
        return {
            ...state,
            activePage: action.payload.activePage
        }; 
    case CredibilityIndexAction.UPDATE_EDIT_CREDIBILITY_BAND:
        return {
            ...state,
            editCredibilityBand: action.payload.editCredibilityBand
        };
    case CredibilityIndexAction.SET_OVERALL_BAND_EDITED:
        return {
            ...state,
            isOverallBandEdited: action.payload.isOverallBandEdited
        };
    case CredibilityIndexAction.IS_LOADING:
        return {
            ...state,
            isLoading: action.payload.isLoading
        };
    case CredibilityIndexAction.RESET_STATE: 
        return initialState;
    default:
      return state;
  }
}

export function DataProvider({ children }: { children: ReactNode }) {
  const [state, dispatch] = useReducer(dataReducer, initialState);
 
  return <DataContext.Provider value={{ state, dispatch }}>
      {children}
    </DataContext.Provider>
}